import React from "react"
import { useTranslation } from "react-i18next"

import { FloorOverlay, FloorOverlayModel } from "../floor-overlay/FloorOverlay"
import { NewFloorOverlayModel } from "./NewFloorOverlay"

export interface NewFloorOverlayViewProps
  extends NewFloorOverlayModel,
    Pick<FloorOverlayModel, "autoFocus" | "formID"> {}

export const NewFloorOverlayView = React.memo(
  ({
    floorFormModel,
    isLoading,
    isSubmitting,
    onCancel,
    autoFocus,
    formID
  }: NewFloorOverlayViewProps) => {
    const { t } = useTranslation()

    return (
      <FloorOverlay
        id="new-floor-overlay"
        formID={formID}
        headline={t("Floor.Actions.Create")}
        prefix="floor__create"
        submitButtonText={t("Floor.Actions.Create")}
        floorFormModel={floorFormModel}
        isLoading={isLoading}
        isSubmitting={isSubmitting}
        autoFocus={autoFocus}
        onCancel={onCancel}
      />
    )
  }
)

NewFloorOverlayView.displayName = "NewFloorOverlayView"
